<template>
  <article class="card">
    <div class="card-image has-text-centered">
      <figure class="image is-square" v-if="thumbnail == null">
        <img src="images/dummy_image.png" />
      </figure>
      <figure
        class="image is-square"
        v-else-if="thumbnail.type.startsWith('image/')"
      >
        <img :src="thumbnail.url" alt="Project thumbnail" />
      </figure>
      <div
        class="video-div fixed-ar fixed-ar-1-1"
        v-else-if="thumbnail != null && thumbnail.type.startsWith('video/')"
      >
        <video :src="thumbnail.url" autoplay loop muted width="100%" />
      </div>
    </div>
    <div class="card-content">
      <div class="media">
        <div class="media-content has-text-centered truncated">
          <p class="title is-4">{{ title }}</p>
          <p class="subtitle is-6 truncated" :title="subtitle">
            {{ subtitle }}
          </p>
        </div>
      </div>

      <div class="level">
        <div class="level-item tags">
          <span class="tag" v-for="skill in skills" v-bind:key="skill.id">
            {{ skill.Name }}
          </span>
        </div>
      </div>
    </div>
    <footer class="card-footer">
      <router-link
        :to="'/project/' + slug"
        class="card-footer-item"
        :class="{ 'is-hidden': !body }"
      >
        More</router-link
      >
      <a
        :href="website"
        class="card-footer-item"
        :class="{ 'is-hidden': !website }"
      >
        Project Page
      </a>
      <a
        :href="repo"
        class="card-footer-item is-info"
        :class="{ 'is-hidden': !repo }"
      >
        Repository
      </a>
    </footer>
  </article>
</template>

<script>
export default {
  name: "PostCard",
  props: {
    title: String,
    subtitle: String,
    thumbnail: Object,
    slug: Number,
    body: String,
    skills: Array,
    website: String,
    repo: String
  }
};
</script>

<style scoped>
.truncated {
  width: auto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.video-div {
  background-color: #000;
}

.video-div video {
  padding-top: 25%;
}

.fixed-ar::before {
  content: "";
  float: left;
  width: 1px;
  margin-left: -1px;
}
.fixed-ar::after {
  content: "";
  display: table;
  clear: both;
}

.fixed-ar-16-9::before {
  padding-top: 56.25%;
}
.fixed-ar-3-2::before {
  padding-top: 66.66%;
}
.fixed-ar-4-3::before {
  padding-top: 75%;
}
.fixed-ar-1-1::before {
  padding-top: 100%;
}
</style>
